import React, { ReactNode, useEffect, useRef } from 'react';

interface IHeadingProps {
  className?: string;
  id?: string;
  children: ReactNode;
}

/**
 * Used for sending focus to the heading element when navigating to a page.
 * This provides a better experience for keyboard users by circumventing the need
 * get sent to the top of the document and have to tab through the navigation every time.
 */
const Heading = ({ className = '', id = '', children }: IHeadingProps) => {
  const titleRef = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { scrollX, scrollY } = window;
      titleRef?.current?.focus();
      // prevents from scrolling back to the top of the screen on back
      window.scrollTo(scrollX, scrollY);
    }
  }, [titleRef]);

  return (
    <h1
      ref={titleRef}
      tabIndex={-1}
      className={`${className}`}
      id={id}
      style={{ outline: 'none' }}
    >
      {children}
    </h1>
  );
};

export default Heading;
